// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html {
  color: var(--text-500);
}

p {
  margin: 0.5em 0 0 0;
}


.pt1 {
  padding-top: 8px;
}

.pt2 {
  padding-top: 16px;
}

.pt3 {
  padding-top: 24px;
}

.pt4 {
  padding-top: 32px;
}

.pt5 {
  padding-top: 40px;
}

.t6 {
  padding-top: 48px;
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/client/src/app.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["\nhtml {\n  color: var(--text-500);\n}\n\np {\n  margin: 0.5em 0 0 0;\n}\n\n\n.pt1 {\n  padding-top: 8px;\n}\n\n.pt2 {\n  padding-top: 16px;\n}\n\n.pt3 {\n  padding-top: 24px;\n}\n\n.pt4 {\n  padding-top: 32px;\n}\n\n.pt5 {\n  padding-top: 40px;\n}\n\n.t6 {\n  padding-top: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
